import type AuthenticationContext from './AuthenticationContext'

const authorizationHeaders = (authContext: AuthenticationContext): Record<string, string> => ({
  Authorization: `Bearer ${authContext.accessToken}`,
  ...(authContext.impersonatedUserId ? { 'X-Impersonate-User-Id': authContext.impersonatedUserId } : {}),
})

export default authorizationHeaders
